// CANONICAL COPY (GH #7115). src/constants/obligations/obl-operating-procedures.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-operating-procedures',
  title: 'Maintain documented operating procedures',
  description:
    'Verify that operating procedures for information processing facilities and security-relevant operations are created, updated, identified, reviewed and made available to personnel who need them. Covers the discipline of creating and updating documented information, not the content of any single policy.',
  category: 'governance',
  scfIds: ['SCF-GOV-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Document control / operating procedures framework is published',
    },
    { type: 'document-within-sla', description: 'Procedure framework review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
